import { useEffect } from 'react'
import LandingPage from '../pages/LandingPage'
import { setReturningVisitorFlag } from '../lib/returningVisitor'

/**
 * Rendered at `/` instead of AppBootstrap when the pow_returning hint is absent —
 * see docs/decisions/2026-08-04-pow-returning-flag.md. Renders the landing page
 * immediately with zero backend dependency, then opportunistically checks in the
 * background whether the visitor actually has a valid session (e.g. the hint was
 * lost but the httpOnly cookie wasn't). That check is non-blocking and its
 * failure is silent — it only ever redirects on success.
 */

const BACKEND = import.meta.env.VITE_API_URL ?? ''

export default function LandingGate() {
  useEffect(() => {
    let cancelled = false

    fetch(`${BACKEND}/api/v1/user/me`, { credentials: 'include' })
      .then((res) => {
        if (cancelled || !res.ok) return
        setReturningVisitorFlag()
        window.location.replace('/home')
      })
      .catch(() => {})

    return () => {
      cancelled = true
    }
  }, [])

  return <LandingPage />
}
